import Locales from './locales';

function initLanguageBanner(textLocale) {
    const promoPanel = $('.wg-header__promo-panel').wgInstance();
    const strings = window.strings.languageBanner;

    if (!promoPanel || !strings) {
        return;
    }

    const bannerHtml = strings[textLocale];
    const $link = $(bannerHtml);
    const relativeTarget = $link.attr('href');
    const isPageTranslated = relativeTarget !== '/';
    const langFromLink = relativeTarget.split('/')[1].toUpperCase();
    const isLinkLocale = Locales.existsLocaleInSite(langFromLink);

    if (!isPageTranslated || !isLinkLocale) {
        return;
    }

    promoPanel.addBanner({
        name: 'language',
        cookie: 'lang-closed',
        priority: 95,
        content: bannerHtml,
        onTarget: (banner, event) => {
            event.preventDefault();

            WG.utils.saveWrikeLocale(textLocale.toLowerCase());

            location.href = location.origin + relativeTarget;
        }
    });
}

function main() {
    const userCountryCode = window.geo.getCountryCodeFromCookie();
    const preferredLocale = Locales.getLocaleByCountry(userCountryCode);
    const isEurope = WG.utils.isEuVisitor();
    const siteLocale = Locales.getSiteLocale();
    const isActualLocale = preferredLocale === siteLocale;
    const hasPreferredLocale = preferredLocale !== null && !isActualLocale;
    const strings = window.strings.languageBanner;
    const isTranslated = preferredLocale in strings;

    if (isEurope && hasPreferredLocale && isTranslated) {
        initLanguageBanner(preferredLocale);
    }
}

$(main);



// WEBPACK FOOTER //
// ./assets/js/common/modules/language-banner.js